import { FC, useCallback, useEffect } from 'react';

import type { Key, KeyboardCallback, Modifier, Propagation } from './shortcut';
import { reactToKeyCombination } from './shortcut';

export interface ShortcutProps {
  code: Key;
  modifier?: Modifier;
  propagation?: Propagation;
  onKeyPress(): void;
}

export const Shortcut: FC<ShortcutProps> = ({ code: key, modifier, propagation = 'CAPTURE', onKeyPress }) => {
  const callback: KeyboardCallback = useCallback(
    (event: KeyboardEvent) => {
      event.preventDefault();
      onKeyPress();
    },
    [onKeyPress],
  );
  useEffect(() => {
    const useCapture = propagation === 'CAPTURE';
    const subscription = reactToKeyCombination({ key, modifier }, callback, { useCapture });
    return () => subscription.unsubscribe();
  }, [key, modifier, propagation, callback]);
  return null;
};
